export default function AppSection() {
  return (
    <section id="app" className="w-full bg-background-100 py-14 md:py-20">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 text-center lg:text-left">
            <span className="text-xs font-semibold text-primary-600 uppercase tracking-wider">移动客户端</span>
            <h2 className="mt-2 text-2xl md:text-3xl font-heading font-bold text-foreground-900">
              移动客户端
            </h2>
            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed max-w-lg mx-auto lg:mx-0">
              芭乐视频移动端适配完美，在手机上也能流畅浏览红桃视频、樱花视频、糖豆视频等平台的聚合内容。无需下载额外App，通过浏览器访问即可享受完整功能，随时随地发现精彩影视。
            </p>

            <div className="mt-6 flex flex-wrap items-center gap-4 justify-center lg:justify-start">
              <div className="flex items-center gap-2 px-4 py-2 rounded-lg bg-background-50 border border-background-200/70">
                <i className="ri-smartphone-line text-primary-500 text-lg"></i>
                <span className="text-xs text-foreground-600">响应式适配</span>
              </div>
              <div className="flex items-center gap-2 px-4 py-2 rounded-lg bg-background-50 border border-background-200/70">
                <i className="ri-speed-mini-line text-accent-500 text-lg"></i>
                <span className="text-xs text-foreground-600">流畅体验</span>
              </div>
              <div className="flex items-center gap-2 px-4 py-2 rounded-lg bg-background-50 border border-background-200/70">
                <i className="ri-download-cloud-2-line text-secondary-500 text-lg"></i>
                <span className="text-xs text-foreground-600">无需下载</span>
              </div>
            </div>

            <a
              href="#hero"
              className="inline-flex items-center gap-2 mt-8 px-8 py-3.5 rounded-full bg-primary-500 text-white text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-qr-scan-line text-lg"></i>
              扫码访问移动版
            </a>
          </div>

          <div className="lg:w-[320px] shrink-0">
            <div className="relative mx-auto w-[220px]">
              <div className="aspect-[9/19] rounded-[2rem] border-4 border-foreground-900 bg-foreground-900 overflow-hidden">
                <div className="h-full bg-background-50 p-3 flex flex-col gap-2">
                  <div className="h-2 w-16 bg-foreground-300 rounded-full mx-auto mt-1"></div>
                  <div className="h-8 bg-primary-500 rounded-lg flex items-center justify-center">
                    <span className="text-white text-xs font-bold">芭乐视频</span>
                  </div>
                  <div className="flex-1 flex flex-col gap-1.5">
                    <div className="h-12 bg-background-200 rounded-lg flex items-center px-2 gap-2">
                      <div className="w-8 h-8 rounded bg-primary-200 shrink-0"></div>
                      <div>
                        <div className="h-1.5 w-16 bg-foreground-300 rounded"></div>
                        <div className="h-1 w-12 bg-foreground-200 rounded mt-1"></div>
                      </div>
                    </div>
                    <div className="h-12 bg-background-200 rounded-lg flex items-center px-2 gap-2">
                      <div className="w-8 h-8 rounded bg-accent-200 shrink-0"></div>
                      <div>
                        <div className="h-1.5 w-20 bg-foreground-300 rounded"></div>
                        <div className="h-1 w-14 bg-foreground-200 rounded mt-1"></div>
                      </div>
                    </div>
                    <div className="h-12 bg-background-200 rounded-lg flex items-center px-2 gap-2">
                      <div className="w-8 h-8 rounded bg-secondary-200 shrink-0"></div>
                      <div>
                        <div className="h-1.5 w-14 bg-foreground-300 rounded"></div>
                        <div className="h-1 w-10 bg-foreground-200 rounded mt-1"></div>
                      </div>
                    </div>
                    <div className="h-16 bg-background-200 rounded-lg"></div>
                    <div className="h-16 bg-background-200 rounded-lg"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}